package com.sddamico.draftmachine.components.layouts

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.ds.DmColor
import com.sddamico.draftmachine.ds.displayFlex
import com.sddamico.draftmachine.ds.motion.pendingContent
import com.sddamico.draftmachine.ds.navigation.Cog
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

/** A whole screen waiting on its data: the app shell with a resting cog in the middle. */
@Composable
fun LoadingFrame() {
  MobileFrame(
    modifier = Modifier.displayFlex().flexDirection(FlexDirection.Column)
      .justifyContent(JustifyContent.Center).alignItems(AlignItems.Center),
  ) {
    // The reveal animation sits on a wrapper because the cog's own spin claims its `animation`.
    Div(attrs = Modifier.pendingContent().toAttrs()) { Cog(size = 48.px, color = DmColor.steel700) }
  }
}

/** A section of a loaded screen still waiting on its own data. */
@Composable
fun LoadingSection(size: CSSLengthNumericValue = 40.px, padding: CSSLengthNumericValue = 40.px) {
  Div(
    attrs = Modifier.displayFlex().justifyContent(JustifyContent.Center).padding(topBottom = padding)
      .pendingContent().toAttrs()
  ) { Cog(size = size, color = DmColor.steel700) }
}
